import React from "react";
import { ChildrenProps } from "@hex-insights/core";
import { PermissionRequired } from "@hex-insights/permissioning";
import { permissions } from "../../../../Utilities";

const createPermissions = [permissions.Newsletter.Create.Admin, permissions.Newsletter.Create.Basic];

export type NewsletterCreatePermissionRequiredProps = Partial<ChildrenProps>;

export function NewsletterCreatePermissionRequired({ children }: NewsletterCreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={createPermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

export type NewsletterUpdatePermissionRequiredProps = {
	isAuthor: boolean;
} & Partial<ChildrenProps>;

export function NewsletterUpdatePermissionRequired({ isAuthor, children }: NewsletterUpdatePermissionRequiredProps) {
	const customCheck = React.useCallback(
		(userPermissions: Record<string, boolean>) => {
			return isAuthor && userPermissions[permissions.Newsletter.Update.Basic];
		},
		[isAuthor],
	);

	return (
		<PermissionRequired
			requiredPermission={permissions.Newsletter.Update.Admin}
			customCheck={customCheck}
			customCheckMethod="or"
		>
			{children}
		</PermissionRequired>
	);
}

export type NewsletterDeletePermissionRequiredProps = {
	isAuthor: boolean;
} & Partial<ChildrenProps>;

export function NewsletterDeletePermissionRequired({ isAuthor, children }: NewsletterDeletePermissionRequiredProps) {
	const customCheck = React.useCallback(
		(userPermissions: Record<string, boolean>) => {
			return isAuthor && userPermissions[permissions.Newsletter.Delete.Basic];
		},
		[isAuthor],
	);

	return (
		<PermissionRequired
			requiredPermission={permissions.Newsletter.Delete.Admin}
			customCheck={customCheck}
			customCheckMethod="or"
		>
			{children}
		</PermissionRequired>
	);
}
